import styled from '@emotion/styled';

import { inlineButtonStyles, outlineButtonStyles, primaryButtonStyles, textButtonStyles } from './variants';

interface ButtonStyleProps {
	$fullWidth?: boolean;
}

/** 스크롤 탑 FAB (기존) */
export const ScrollTopFabBox = styled.div`
	position: fixed;
	right: 3rem;
	bottom: 3rem;
	z-index: 1;

	@media (max-width: 1180px) {
		right: 2rem;
		bottom: 1.8rem;
	}
`;

export const ScrollTopFab = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 5.6rem;
	height: 5.6rem;
	background-color: ${(props) => props.theme.ui.interactive.primary};
	border: none;
	border-radius: ${(props) => props.theme.effects.radiusFull};
	box-shadow: ${(props) => props.theme.effects.shadowMd};
	cursor: pointer;
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		box-shadow ${(props) => props.theme.effects.transitionFast},
		transform ${(props) => props.theme.effects.transitionFast};

	&:hover {
		background-color: ${(props) => props.theme.ui.interactive.primaryHover};
		box-shadow: ${(props) => props.theme.effects.shadowLg};
		transform: translateY(-2px);
	}

	@media (max-width: 1180px) {
		width: 4.4rem;
		height: 4.4rem;
	}
`;

/** 폼·페이지 공통 버튼 */
export const PrimaryButton = styled.button<ButtonStyleProps>`
	${(props) => primaryButtonStyles(props.theme, props.$fullWidth)};
`;

export const InlineButton = styled.button`
	${(props) => inlineButtonStyles(props.theme)};
`;

export const OutlineButton = styled.button<ButtonStyleProps>`
	${(props) => outlineButtonStyles(props.theme, props.$fullWidth)};
`;

export const TextButton = styled.button`
	${(props) => textButtonStyles(props.theme)};
`;

/** @deprecated ScrollTopFabBox — SideButton 전용 */
export const ButtonBox = ScrollTopFabBox;
/** @deprecated ScrollTopFab — SideButton 전용 */
export const Button = ScrollTopFab;

/** 레거시 re-export (기존 NextButton / FindButton 교체용) */
export const NextButton = PrimaryButton;
export const FindButton = InlineButton;
